import { Component, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { v4 as uuidv4 } from 'uuid';

export interface ArkoseErrorDialogData {
  product?: string;
  sessionId?: string;
  reason?: string;
}

@Component({
  selector: 'app-arkose-error-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  templateUrl: './arkose-error-dialog.component.html',
  styleUrl: './arkose-error-dialog.component.scss'
})
export class ArkoseErrorDialogComponent {
  reference: string = uuidv4().replace(/-/g, '').substring(0, 20);
  time: string = new Date().toISOString();

  constructor(
    public dialogRef: MatDialogRef<ArkoseErrorDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: ArkoseErrorDialogData
  ) { }

  close(): void {
    this.dialogRef.close();
  }
}
